import { render, staticRenderFns } from "./psuBmfAffirmForm.vue?vue&type=template&id=7a8fef21&scoped=true"
import script from "./psuBmfAffirmForm.vue?vue&type=script&lang=js"
export * from "./psuBmfAffirmForm.vue?vue&type=script&lang=js"
import style0 from "./psuBmfAffirmForm.vue?vue&type=style&index=0&id=7a8fef21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8fef21",
  null
  
)

export default component.exports